var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 4.33341V3.00008C8.33333 2.64646 8.19286 2.30732 7.94281 2.05727C7.69276 1.80722 7.35362 1.66675 7 1.66675H2.33333C1.97971 1.66675 1.64057 1.80722 1.39052 2.05727C1.14048 2.30732 1 2.64646 1 3.00008V11.0001C1 11.3537 1.14048 11.6928 1.39052 11.9429C1.64057 12.1929 1.97971 12.3334 2.33333 12.3334H7C7.35362 12.3334 7.69276 12.1929 7.94281 11.9429C8.19286 11.6928 8.33333 11.3537 8.33333 11.0001V9.66675",
    stroke: "#FF8181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 7H13M13 7L11 5M13 7L11 9",
    stroke: "#FF8181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b981598c082f0ab6fcabb66f888a9467.svg";
export { ForwardRef as ReactComponent };